import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	blankRow: {
		/* eslint-disable-next-line jira/i18n/id-named-by-package */
		id: 'native-issue-table.issue-row.blank-row.blank-row',
		defaultMessage: "We can't display this issue",
		description: 'Text that shows when an issue can no longer be opened from the issue list',
	},
	blankRowText: {
		id: 'native-issue-table.row.blank-row.blank-row-text',
		defaultMessage:
			'This issue cannot be opened because it may have been deleted or you do not have access to it',
		description: 'Text that shows when an issue can no longer be opened from the issue list',
	},
	tooltip: {
		/* eslint-disable-next-line jira/i18n/id-named-by-package */
		id: 'native-issue-table.issue-row.blank-row.tooltip',
		defaultMessage: 'Either this issue has been deleted, or you don’t have access to it.',
		description: 'Tooltip text for blank row information icon',
	},
});
